import { legacy_createStore as createStore, compose, applyMiddleware } from 'redux';
import { ENVIRONMENTS } from '~/constants';

export default (reducers, middlewares) => {
  const enhancer =
    process.env.NODE_ENV === ENVIRONMENTS.LOCAL
      ? compose(console.tron.createEnhancer(), applyMiddleware(...middlewares))
      : applyMiddleware(...middlewares);
  return createStore(reducers, enhancer);
};
